export default __webpack_public_path__ + "static/media/Example2.23972f1e.jpeg";